import { render, staticRenderFns } from "./StreetAddressTextField.vue?vue&type=template&id=12e4a628"
import script from "./StreetAddressTextField.vue?vue&type=script&lang=ts"
export * from "./StreetAddressTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports